import React from 'react'
import '../../../css/pages/form.css'

const SingleLineSearchForm = ({children, fields, onSearch}) => (
  <form onSubmit={e => e.preventDefault()}>
    <div>
    {children}
    {fields && (
      <div className="form-group col">
        <label className="col-form-label col-form-label-sm">&nbsp;</label>
        <div>
          <button
            className="btn btn-primary btn-rounded"
            type="submit"
            onClick={onSearch}>
            Search
          </button>
        </div>
      </div>
    )}
    </div>
  </form>
)

export default SingleLineSearchForm
